function readSearchParams(location) {
  const search = new URLSearchParams(location?.search || "");
  const hashRaw = String(location?.hash || "").replace(/^#/, "");
  const hashQuery = hashRaw.includes("?")
    ? hashRaw.slice(hashRaw.indexOf("?") + 1)
    : hashRaw.includes("=")
      ? hashRaw
      : "";
  return {
    search,
    hash: new URLSearchParams(hashQuery),
    hashRaw,
  };
}

function readForgotResetFromLocation(location = window.location) {
  const { search, hash, hashRaw } = readSearchParams(location);
  const email = String(search.get("email") || hash.get("email") || "").trim().toLowerCase();
  const code = String(search.get("code") || hash.get("code") || "").trim();
  const reset =
    search.get("reset") === "1" ||
    search.has("reset") ||
    hash.get("reset") === "1" ||
    hashRaw === "reset" ||
    hashRaw.startsWith("reset");
  if (!reset && !code && !email) return null;
  if (!reset && !code) return null;
  return { email, code };
}

function clearForgotResetFromLocation(
  location = window.location,
  historyApi = window.history
) {
  const url = new URL(location.href);
  url.searchParams.delete("reset");
  url.searchParams.delete("email");
  url.searchParams.delete("code");
  if (url.hash && /reset|email=|code=/.test(url.hash)) {
    url.hash = "";
  }
  const next = `${url.pathname}${url.search}${url.hash}`;
  historyApi.replaceState(null, "", next);
  return next;
}

module.exports = {
  readForgotResetFromLocation,
  clearForgotResetFromLocation,
};
